function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { EMAIL, STATUSES, CHAT, PHONE } from '../enums';

var buildContactItem = function buildContactItem(_ref) {
  var data = _ref.data;
  var CLOSED = STATUSES.CLOSED,
      OPEN = STATUSES.OPEN;
  var values = {};

  if (data.settings.visible) {
    if (data.output.type === EMAIL && data.output.status === CLOSED) {
      values = _extends({}, values, {
        mayShow: false
      });
    } else if (data.output.type === EMAIL && data.output.status === OPEN && data.output.subscriptionpage) {
      values = _extends({}, values, {
        mayShow: false
      });
    } else {
      // Show the contact element
      values = _extends({}, values, {
        mayShow: true,
        mainText: data.output.display.maintext,
        editText: data.output.display.edittext
      });
    }
  } else {
    // Hide the contact element
    values = _extends({}, values, {
      mayShow: false
    });
  }

  switch (data.output.type) {
    case CHAT:
      if (data.output.subscriptionpage) {
        values = _extends({}, values, {
          link: data.contactdetails.subscriptionchat_link
        });
      } else {
        values = _extends({}, values, {
          link: data.contactdetails.chat_link
        });
      }

      if (data.output.status === 'OPEN') {
        values = _extends({}, values, {
          bChatActive: true
        });
      }

      break;

    case EMAIL:
      values = _extends({}, values, {
        link: data.settings.emaillink
      });
      break;

    case PHONE:
      if (data.output.subscriptionpage) {
        values = _extends({}, values, {
          link: "tel:+" + (MH_BRAND === BRANDS.DL ? '31' : '32' // Remove first character and remove all white spaces.
          ) + data.settings.subscriptiontelnr.slice(1).replace(/ /g, '')
        });
      } else {
        values = _extends({}, values, {
          link: "tel:+" + (MH_BRAND === BRANDS.DL ? '31' : '32' // Remove first character and remove all white spaces.
          ) + data.settings.telnr.slice(1).replace(/ /g, '')
        });
      }

      break;

    default:
      break;
  }

  return values;
};

export default buildContactItem;